import { EventEmitterBase } from '../utils';
import { MediaControllerState, StateControllerEvents } from './enums';
import { PlayerStateChangeArgs } from './models';

export class StateController extends EventEmitterBase {

    private _seeking: boolean = false;
    private _state: MediaControllerState = MediaControllerState.Loading;

    set seeking(seeking: boolean) {
        this._seeking = seeking;
    }

    get seeking(): boolean {
        return this._seeking;
    }

    set state(state: MediaControllerState) {
        const _old = this._state;
        if (_old !== state) {
            this._state = state;
            const event: PlayerStateChangeArgs = {
                oldState: _old,
                newState: state,
            };
            this.emit(StateControllerEvents.StateChange, event);
        }
    }

    get state(): MediaControllerState {
        return this._state;
    }

}
